var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#222831;}.cls-2{fill:#f05454;stroke:#f4f4f4;}.cls-2,.cls-6{stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.cls-3{fill:#7f2e2e;opacity:0.5;}.cls-4{fill:#232020;}.cls-5{fill:#fff;}.cls-6{fill:none;stroke:#232020;}.cls-7{fill:#f4f4f4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 250,
    height: 250,
    rx: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125,47c-57.9,0-95.5,52.14-95.5,88,0,45,27.5,68,95.5,68s95.5-23,95.5-68C220.5,99.14,182.9,47,125,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125,133.68c-62.16,0-83.18,21.32-83.18,31.55,0,15.34,30.5,34,83.18,34s83.18-18.68,83.18-34C208.18,155,187.16,133.68,125,133.68Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 189.5,
    cy: 145.93,
    rx: 9.5,
    ry: 11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 188.07,
    cy: 144.36,
    r: 5.17
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 60.5,
    cy: 145.93,
    rx: 9.5,
    ry: 11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 61.93,
    cy: 144.36,
    r: 5.17
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M141,160.06c-4.51,5.75-11.2,5.67-16,0-4.8,5.67-11.49,5.75-16,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M45.46,104.83c10-21,37.81-39.1,42.11-36.33,7,4.5-24.91,19.5-25.65,38.94C61.53,117.74,36,124.61,45.46,104.83Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 96.07,
    cy: 64.88,
    rx: 3.68,
    ry: 3.13,
    transform: "translate(-16.44 36.96) rotate(-20.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M211,152.52c2.82.77,7.74-19.23,1.2-29.4s-5.83,3-3.37,8.67C212.56,140.39,208.69,151.88,211,152.52Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.95f0dae1e6326f5be41734f6b395d999.svg";
export { ForwardRef as ReactComponent };